// src/firebase.js
// Firebase initialization for GPS Tech Holdings

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBEI6EauPDph35WD07CnBDfdxIp9vWyAIg",
  authDomain: "gpstechza.firebaseapp.com",
  projectId: "gpstechza",
  storageBucket: "gpstechza.firebasestorage.app",
  messagingSenderId: "611361935595",
  appId: "1:611361935595:web:b043437584abfa2eacaeae",
  measurementId: "G-BREZRYCB2C"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
export default app;